<template>
	<v-dialog v-model="dialog" persistent max-width="460" content-class="rounded-xl">
		<v-card>
			<v-card-title class="h6 justify-start">Konfirmasi</v-card-title>
			<v-card-text class="text-left">
				<div class="d-block text-left mb-3" v-if="network_code">
					<div class="d-flex">
						<div class="pa-0 col-6 col-sm-4 d-flex flex-wrap justify-space-between">
							<span>Kode Mitra</span>
							<span>:</span>
						</div>
						<div class="pl-1 pr-0 py-0 col-6 col-sm-8 font-weight-bold">{{ network_code | emptyData }}</div>
					</div>
				</div>
				<div class="d-block text-left mb-3" v-if="nama_mitra">
					<div class="d-flex">
						<div class="pa-0 col-6 col-sm-4 d-flex flex-wrap justify-space-between">
							<span>Nama Mitra</span>
							<span>:</span>
						</div>
						<div class="pl-1 pr-0 py-0 col-6 col-sm-8 font-weight-bold">{{ nama_mitra | emptyData }}</div>
					</div>
				</div>
				<div>
					Apakah Anda yakin untuk memproses kirim <b>{{ serialqty }}</b> Serial {{ serialtype }}?
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize rounded-xl" :loading="btn_loading" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-btn color="primary" depressed class="text-capitalize rounded-xl" :loading="btn_loading" @click.stop="confirm">{{ confirmText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			dialog: false,
			btn_loading: false,
			closeText: 'Batal',
			confirmText: 'Yakin'
		}
	},
	props: {
		network_code: String,
		nama_mitra: String,
		serialqty: Number,
		serialtype: String
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.dialog = false
		},
		modalShow() {
			this.dialog = true
		},
		loadingButton() {
			this.btn_loading = true
		},
		normalButton() {
			this.btn_loading = false
		},
		confirm() {
			this.$emit('action')
		}
	}
};
</script>